import { cutFileExtension } from '../cutFileExtension'
import isIOS from '../is/isIOS'
import { logger } from '../logger'

export type VideoInfo = {
  src: string
  name: string
  duration: number
  width: number
  height: number
  preview?: string
}

type TGetVideoInfo = {
  src: string
  name?: string
}

export const getVideoPropsFromFile = (file: File) => ({
  name: file.name,
  src: URL.createObjectURL(file),
})

const getVideoInfo = ({ src, name = '' }: TGetVideoInfo) =>
  new Promise<VideoInfo | null>((resolve, reject) => {
    const video = document.createElement('video')
    video.src = src

    const onLoadedData = () => {
      const { duration, videoHeight, videoWidth, src } = video
      const cuttedName = cutFileExtension(name)

      if (!duration || !videoHeight || !videoWidth || !src) reject()

      resolve({
        src,
        name: cuttedName,
        width: videoWidth,
        height: videoHeight,
        duration: Math.floor(duration),
      })
    }

    const onError = () => {
      logger.warn('Failed to load video')
      resolve(null)
    }

    isIOS() && video.load()

    video.addEventListener('error', onError)
    video.addEventListener('loadeddata', onLoadedData)

    return () => {
      video.removeEventListener('error', onError)
      video.removeEventListener('loadeddata', onLoadedData)
    }
  })

export default getVideoInfo
